import { createAction, props } from '@ngrx/store';
import { PassengerInformationInputModalState } from './passenger-information-input-modal.state';

/** StateDetailsActions */
const ACTION_SET = '[PassengerInformationInputModal] set';
const ACTION_UPDATE = '[PassengerInformationInputModal] update';
const ACTION_RESET = '[PassengerInformationInputModal] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setPassengerInformationInputModal = createAction(ACTION_SET, props<PassengerInformationInputModalState>());

/**
 * Change a part or the whole object in the store.
 */
export const updatePassengerInformationInputModal = createAction(
  ACTION_UPDATE,
  props<Partial<PassengerInformationInputModalState>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetPassengerInformationInputModal = createAction(ACTION_RESET);
